
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import ItemForm from './Form.vue';

const invitationCodeApi = api.invitationCode;

@Component({
  components: { ItemForm },
})
export default class InvitationCodeCreate extends Vue {
  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await invitationCodeApi.add(form);
      this.loading = false;
      if (status === 1) {
        await this.$router.back();
      }
    }
  }
}
